import { defineMessages } from 'react-intl';
import { ParameterName } from './types';

const messages = defineMessages({
  defaultParameters: {
    id: 'defaultParameters',
    defaultMessage: 'Default Parameters',
  },
  groupParameters: {
    id: 'groupParameters',
    defaultMessage: 'Group Parameters',
  },
  articleParameters: {
    id: 'articleParameters',
    defaultMessage: 'Parameters per article',
  },
  f6Parameters: {
    id: 'f6Parameters',
    defaultMessage: 'F6 Parameters',
  },
  storeLevelDefaultsTitle: {
    id: 'storeLevelDefaultsTitle',
    defaultMessage: 'Store Level Default Values',
  },
  divisionLevelDefaultValues: {
    id: 'divisionLevelDefaultValues',
    defaultMessage: 'Division Level Default Values',
  },
  hfbLevelDefaultValues: {
    id: 'hfbLevelDefaultValues',
    defaultMessage: 'HFB Level Default Values',
  },
  hfb: {
    id: 'hfb',
    defaultMessage: 'HFB',
  },
  approveParameterTooltip: {
    id: 'approveParameterTooltip',
    defaultMessage: 'Order critical parameter, click to confirm',
  },
  approveParameterTitle: {
    id: 'approveParameterTitle',
    defaultMessage: 'Approve change',
  },
  approveParameterBodyStart: {
    id: 'approveParameterBodyStart',
    defaultMessage:
      'This is an order critical parameter! A change must be approved by the responsible function.',
  },
  approveParameterBodyEnd: {
    id: 'approveParameterBodyEnd',
    defaultMessage: 'Do you want to continue?',
  },
  loadingError: {
    id: 'loadingError',
    defaultMessage: 'Failed to load parameters',
  },
  saving: {
    id: 'saving',
    defaultMessage: 'Saving updated parameters...',
  },
  /**
   * @deprecated
   */
  savingError: {
    id: 'savingError',
    defaultMessage: 'Failed to save updated parameters',
  },
  /**
   * @deprecated
   */
  savingSuccess: {
    id: 'savingSuccess',
    defaultMessage: 'Successfully updated parameters',
  },
  articleNumber: {
    id: 'articleNumber',
    defaultMessage: 'Art. No.',
    description: 'Article Number, abbreviated',
  },
  parameterValues: {
    id: 'parameterValues',
    defaultMessage: 'Parameter Values',
  },
  parameterValue: {
    id: 'parameterValue',
    defaultMessage: 'Parameter Value',
  },
  article: {
    id: 'article',
    defaultMessage: 'Article',
  },
  parameter: {
    id: 'parameter',
    defaultMessage: 'Parameter',
  },
  filter: {
    id: 'filter',
    defaultMessage: 'Filter',
  },
  filterValue: {
    id: 'filterValue',
    defaultMessage: 'Filter value',
  },
  chooseParameter: {
    id: 'chooseParameter',
    defaultMessage: 'Choose parameter',
  },
  chooseFilter: {
    id: 'chooseFilter',
    defaultMessage: 'Choose filter',
  },
  chooseFilterValue: {
    id: 'chooseFilterValue',
    defaultMessage: 'Choose filter value',
  },
  hfbFilter: {
    id: 'hfb',
    defaultMessage: 'HFB',
  },
  rangeAreaFilter: {
    id: 'rangeAreaFilter',
    defaultMessage: 'Range area',
  },
  salesMethodFilter: {
    id: 'salesMethodFilter',
    defaultMessage: 'Sales method',
  },
  salesMethod0: {
    id: 'salesMethod0',
    defaultMessage: '0 - Satellite',
  },
  salesMethod1: {
    id: 'salesMethod1',
    defaultMessage: '1 - Self serve',
  },
  salesMethod2: {
    id: 'salesMethod2',
    defaultMessage: '2 - Full Serve',
  },
  serviceClassFilter: {
    id: 'serviceClassFilter',
    defaultMessage: 'Service class',
  },
  serviceClass1: {
    id: 'serviceClass1',
    defaultMessage: 'Service class 1',
  },
  serviceClass2: {
    id: 'serviceClass2',
    defaultMessage: 'Service class 2',
  },
  serviceClass3: {
    id: 'serviceClass3',
    defaultMessage: 'Service class 3',
  },
  serviceClass4: {
    id: 'serviceClass4',
    defaultMessage: 'Service class 4',
  },
  serviceClass5: {
    id: 'serviceClass5',
    defaultMessage: 'Service class 5',
  },
  serviceClassFilterNotImplemented: {
    id: 'serviceClassFilterNotImplemented',
    defaultMessage: 'Filtering by Service class is not yet implemented.',
  },

  noArticlesTitle: {
    id: 'noArticlesTitle',
    defaultMessage: 'No articles',
  },
  noArticlesBody: {
    id: 'noArticlesBody',
    defaultMessage: 'No articles found for this filter.',
  },

  newParameterValue: {
    id: 'newParameterValue',
    defaultMessage: 'New parameter value',
  },

  confirmUpdateTitle: {
    id: 'confirmUpdateTitle',
    defaultMessage: 'Confirm Parameter update',
  },
  confirmUpdateBody: {
    id: 'confirmUpdateBody',
    defaultMessage:
      'Are you sure you want to update the Parameters to their new values?',
  },

  confirmResetTitle: {
    id: 'confirmResetTitle',
    defaultMessage: 'Confirm Parameter reset',
  },
  confirmResetBody: {
    id: 'confirmResetBody',
    defaultMessage:
      'Are you sure you want to reset the Parameters to their default values?',
  },

  oldValue: {
    id: 'oldValue',
    defaultMessage: 'Old value',
  },
  newValue: {
    id: 'newValue',
    defaultMessage: 'New value',
  },
  blankValue: {
    id: 'blankValue',
    defaultMessage: '-',
    description: 'Indicates a blank value',
  },

  f6Parameter: {
    id: 'f6Parameter',
    defaultMessage: 'F6 Parameter',
  },
  hfbParameter: {
    id: 'hfbParameter',
    defaultMessage: 'HFB Parameter',
  },
  divisionParameter: {
    id: 'divisionParameter',
    defaultMessage: 'Default Division Parameter',
  },
  storeParameter: {
    id: 'storeParameter',
    defaultMessage: 'Default Parameter',
  },
  itemParameter: {
    id: 'itemParameter',
    defaultMessage: 'Item Parameter',
  },
});

const constraintMessages = {
  // Placeholder, pending O14 validation refactor on backend
};

const useCaseMessages = {
  updateStoreParameters: defineMessages({
    error: {
      defaultMessage: 'Error updating Store Level Default Values',
      id: 'updateStoreParametersError',
    },
    success: {
      defaultMessage: 'Updated Store Level Default Values',
      id: 'updateStoreParametersSuccess',
    },
  }),
  updateDivisionParameters: defineMessages({
    error: {
      defaultMessage: 'Error updating Division Level Default Values: {name}',
      id: 'updateDivisionParametersError',
    },
    success: {
      defaultMessage: 'Updated Division Level Default Values: {name}',
      id: 'updateDivisionParametersSuccess',
    },
  }),
  updateHfbParameters: defineMessages({
    error: {
      defaultMessage: 'Error updating HFB Level Default Values: {name}',
      id: 'updateHfbParametersError',
    },
    success: {
      defaultMessage: 'Updated HFB Level Default Values: {name}',
      id: 'updateHfbParametersSuccess',
    },
  }),
  updateGroupParameter: defineMessages({
    error: {
      defaultMessage: 'Error updating Group parameter: {parameter}',
      id: 'updateGroupParametersError',
    },
    success: {
      defaultMessage: 'Updated Group parameter: {parameter}',
      id: 'updateGroupParametersSuccess',
    },
  }),
  updateArticleParameters: defineMessages({
    error: {
      defaultMessage: 'Error updating parameters for Article: {articleNumber}',
      id: 'updateArticleParametersError',
    },
    success: {
      defaultMessage: 'Updated parameters for Article: {articleNumber}',
      id: 'updateArticleParametersSuccess',
    },
  }),
  updateF6Parameters: defineMessages({
    error: {
      defaultMessage: 'Error updating F6 Parameters',
      id: 'updateF6ParametersError',
    },
    success: {
      defaultMessage: 'Updated F6 Parameters',
      id: 'updateF6ParametersSuccess',
    },
  }),
};

const parameterShortMessages = defineMessages({
  parameterBackpanelVolumeAvg: {
    id: 'parameterBackpanelVolumeAvg',
    defaultMessage: 'BACKPANEL VOLUME',
    description: 'Parameter name for Backpanel Volume Average',
    enumValue: ParameterName.BACKPANEL_VOL_AVG,
  },
  parameterCommQtyLimitDays: {
    id: 'parameterCommQtyLimitDays',
    defaultMessage: 'COMM QTY LIMIT DAYS',
    description: 'Parameter name for Commercial Quantity Limit Days',
    enumValue: ParameterName.COMM_QTY_LIMIT_DAYS,
  },
  parameterCovDaysDirect: {
    id: 'parameterCovDaysDirect',
    defaultMessage: 'COV DAYS DIRECT',
    description: 'Parameter name for Coverage days for direct flow',
    enumValue: ParameterName.COV_DAYS_DIRECT,
  },
  parameterCovDaysDtfpPlus: {
    id: 'parameterCovDaysDtfpPlus',
    defaultMessage: 'COV DAYS DTFP+',
    description: 'Parameter name for Coverage days for stable direct flow',
    enumValue: ParameterName.COV_DAYS_DTFPP,
  },
  parameterCovDaysIndirect: {
    id: 'parameterCovDaysIndirect',
    defaultMessage: 'COV DAYS INDIRECT',
    description: 'Parameter name for Coverage days for indirect flow',
    enumValue: ParameterName.COV_DAYS_INDIRECT,
  },
  parameterDeliveryMaxParam: {
    id: 'parameterDeliveryMaxParam',
    defaultMessage: 'DEL MAX',
    description: 'Parameter name for Delivery Max',
    enumValue: ParameterName.DELIVERY_MAX_PARAM,
  },
  parameterDirectDelPicking: {
    id: 'parameterDirectDelPicking',
    defaultMessage: 'DD PICKING',
    description: 'Parameter name for direct delivery picking',
    enumValue: ParameterName.DIRECT_DEL_PICKING,
  },
  parameterFlexibilityPct: {
    id: 'parameterFlexibilityPct',
    defaultMessage: 'FLEX %',
    description: 'Parameter name for flexibility percent',
    enumValue: ParameterName.FLEXIBILITY_PCT,
  },
  parameterAvgHandstackVolume: {
    id: 'parameterAvgHandstackVolume',
    defaultMessage: 'AVG HANDSTACK VOLUME',
    description: 'Parameter name for average volume per handstack location',
    enumValue: ParameterName.HANDSTACK_CAP_FACTOR,
  },
  parameterMaxSafetyStockD: {
    id: 'parameterMaxSafetyStockD',
    defaultMessage: 'MAX_SAFETY_STOCK_D',
    description: 'Parameter name for max safety stock days',
    enumValue: ParameterName.MAX_SAFETY_STOCK_D,
  },
  parameterMinSafetyStock: {
    id: 'parameterMinSafetyStock',
    defaultMessage: 'MIN SAFETY STOCK',
    description: 'Parameter name for min safety stock',
    enumValue: ParameterName.MIN_SAFETY_STOCK,
  },
  parameterOrderFullPltOnly: {
    id: 'parameterOrderFullPltOnly',
    defaultMessage: 'ORDER FULL PLT ONLY',
    description: 'Parameter name for forcing full pallet orders',
    enumValue: ParameterName.ORDER_FULL_PLT_ONLY,
  },
  parameterOverstockLimitDays: {
    id: 'parameterOverstockLimitDays',
    defaultMessage: 'OVERSTOCK LIMIT DAYS',
    description: 'Parameter name for overstock limit days',
    enumValue: ParameterName.OVERSTOCK_LIMIT_DAYS,
  },
  parameterPalletRoundFactor: {
    id: 'parameterPalletRoundFactor',
    defaultMessage: 'PALLET ROUND FACTOR',
    description: 'Parameter name for pallet round factor',
    enumValue: ParameterName.PALLET_ROUND_FACTOR,
  },
  parameterBiggestPeakdayFactor: {
    id: 'parameterBiggestPeakdayFactor',
    defaultMessage: 'BIGGEST PEAKDAY FACTOR',
    description: 'Parameter name for biggest peakday factor',
    enumValue: ParameterName.PEAK_DAY_FACTOR_PCT,
  },
  parameterRangeAllocSfWh: {
    id: 'parameterRangeAllocSfWh',
    defaultMessage: 'RANGE ALLOC SF/WH',
    description: 'Parameter name for range allocation ratio',
    enumValue: ParameterName.RANGE_ALLOC_RATIO,
  },
  parameterUnitLoadLimit: {
    id: 'parameterUnitLoadLimit',
    defaultMessage: 'UNIT LOAD LIMIT',
    description: 'Parameter name for unit load limit',
    enumValue: ParameterName.UNIT_LOAD_LIMIT,
  },
  parameterCommQty: {
    id: 'parameterCommQty',
    defaultMessage: 'COMM QTY (ON/OFF)',
    description: 'Parameter name for calculating commercial quantity',
    enumValue: ParameterName.COMM_QTY_LIMIT_DAYS,
  },
  parameterHighTurnoverMark: {
    id: 'parameterHighTurnoverMark',
    defaultMessage: 'TURN OVER RANK DTFP+',
    description: 'Parameter name for turn over rank DTFP+',
    enumValue: ParameterName.TURNOVERRANKDTFPP,
  },
  parameterLowTurnoverMark: {
    id: 'parameterLowTurnoverMark',
    defaultMessage: 'TURN OVER RANK MIN',
    description: 'Parameter name for min turn over rank',
    enumValue: ParameterName.TURNOVERRANKMIN,
  },
  parameterTurnoverMarkDTFP: {
    id: 'parameterTurnoverMarkDTFP',
    defaultMessage: 'TURN OVER RANK DTFP',
    description: 'Parameter name for turn over rank DTFP',
    enumValue: ParameterName.TURNOVERRANKDTFP,
  },
  alertAssqOverMax: {
    id: 'alertAssqOverMax',
    defaultMessage: 'ASSQ bigger than max',
    description: 'An alert indicating that ASSQ is over MAX',
    enumValue: ParameterName.ALERT_OVER_MAX,
  },
  alertAssqUnderMin: {
    id: 'alertAssqUnderMin',
    defaultMessage: 'ASSQ less than min',
    description: 'An alert indicating that ASSQ is under MIN',
    enumValue: ParameterName.ALERT_UNDER_MIN,
  },
  alertLocLocShortage: {
    id: 'alertLocLocShortage',
    defaultMessage: 'Local local shortage',
    description: 'An alert indicating that there is a Local local shortage',
    enumValue: ParameterName.ALERT_LOC_LOC_SHORT,
  },
  alertUnplannedArticle: {
    id: 'alertUnplannedArticle',
    defaultMessage: 'Unplanned article',
    description: 'An alert indicating that there is an unplanned article',
    enumValue: ParameterName.ALERT_UNPLANNED_ART,
  },
  parameterSmallStoreMinDeliveryQty: {
    id: 'parameterSmallStoreMinDeliveryQty',
    defaultMessage: 'SMDQ (Small store)',
    description: 'Parameter name for Small Store Minimum Delivery Quantity',
    enumValue: ParameterName.SMALL_STORE_MINIMUM_DELIVERY_QUANTITY,
  },
  parameterSlmDirFlowGreen: {
    id: 'parameterSlmDirFlowGreen',
    defaultMessage: 'DIR FLOW GREEN',
    description:
      'Parameter name for the green threshold of the direct flow traffic light (F6)',
    enumValue: ParameterName.SLM_DIR_FLOW_GREEN,
  },
  parameterSlmDirFlowYellow: {
    id: 'parameterSlmDirFlowYellow',
    defaultMessage: 'DIR FLOW YELLOW',
    description:
      'Parameter name for the yellow threshold of the direct flow traffic light (F6)',
    enumValue: ParameterName.SLM_DIR_FLOW_YELLOW,
  },
  parameterSlmExcessiveDays: {
    id: 'parameterSlmExcessiveDays',
    defaultMessage: 'EXCESSIVE DAYS',
    description: 'Parameter name for SLM Excessive Days (F6)',
    enumValue: ParameterName.SLM_EXCESSIVE_DAYS,
  },
  parameterSlmExcessiveLimit: {
    id: 'parameterSlmExcessiveLimit',
    defaultMessage: 'EXCESSIVE LIMIT',
    description: 'Parameter name for SLM Excessive Limit (F6)',
    enumValue: ParameterName.SLM_EXCESSIVE_LIMIT,
  },
  parameterSlmMinIndelAmount: {
    id: 'parameterSlmMinIndelAmount',
    defaultMessage: 'MIN INDEL AMOUNT',
    description: 'Parameter name for Minimum Indelivery Amount (F6)',
    enumValue: ParameterName.SLM_MIN_INDEL_AMOUNT,
  },
  parameterSlmNewArtWeeks: {
    id: 'parameterSlmNewArtWeeks',
    defaultMessage: 'NEW ART WEEKS',
    description: 'Parameter name for SLM New Article Weeks (F6)',
    enumValue: ParameterName.SLM_NEW_ART_WEEKS,
  },
  parameterSlmSlidStartDays: {
    id: 'parameterSlmSlidStartDays',
    defaultMessage: 'SLID START DAYS',
    description: 'Parameter name for SLM SL-ID Start Days (F6)',
    enumValue: ParameterName.SLM_SLID_START_DAYS,
  },
  parameterSlmWarnAssqDays: {
    id: 'parameterSlmWarnAssqDays',
    defaultMessage: 'WARN ASSQ DAYS',
    description: 'Parameter name for SLM Warning ASSQ Days (F6)',
    enumValue: ParameterName.SLM_WARN_ASSQ_DAYS,
  },
  parameterSlmWarnUnplanDays: {
    id: 'parameterSlmWarnUnplanDays',
    defaultMessage: 'WARN UNPLAN DAYS',
    description: 'Parameter name for SLM Warning Unplanned Days (F6)',
    enumValue: ParameterName.SLM_WARN_UNPLAN_DAYS,
  },
});

const parameterTooltipMessages = defineMessages({
  parameterBackpanelVolumeAvgTooltip: {
    id: 'parameterBackpanelVolumeAvgTooltip',
    defaultMessage:
      'Average backpanel (shelf) volume (in m3) used to calculate space need and space',
    description: 'Tooltip for the Backpanel Volume Average parameter',
    enumValue: ParameterName.BACKPANEL_VOL_AVG,
  },
  parameterCommQtyLimitDaysTooltip: {
    id: 'parameterCommQtyLimitDaysTooltip',
    defaultMessage:
      'minimum number of forecasted daily sales needed to be covered between the max',
    description: 'Tooltip for the Commercial Quantity Limit Days parameter',
    enumValue: ParameterName.COMM_QTY_LIMIT_DAYS,
  },
  parameterCovDaysDirectTooltip: {
    id: 'parameterCovDaysDirectTooltip',
    defaultMessage:
      'Minimum number of forecasted daily sales needed for coverage until the next replenishment for direct flow',
    description: 'Tooltip for the Coverage days for direct flow parameter',
    enumValue: ParameterName.COV_DAYS_DIRECT,
  },
  parameterCovDaysDtfpPlusTooltip: {
    id: 'parameterCovDaysDtfpPlusTooltip',
    defaultMessage:
      'Minimum number of forecasted daily sales needed for coverage until the next replenishment for stable direct flow',
    description:
      'Tooltip for the Coverage days for stable direct flow parameter',
    enumValue: ParameterName.COV_DAYS_DTFPP,
  },
  parameterCovDaysIndirectTooltip: {
    id: 'parameterCovDaysIndirectTooltip',
    defaultMessage:
      'Minimum number of forecasted daily sales needed for coverage until the next replenishment for stable direct flow',
    description: 'Tooltip for the Coverage days for indirect flow parameter',
    enumValue: ParameterName.COV_DAYS_INDIRECT,
  },

  parameterDeliveryMaxParamTooltip: {
    id: 'parameterDeliveryMaxParamTooltip',
    defaultMessage:
      'Maximum number of extra pallets that the store can receive for an article to maximize filling rate in the trucks',
    description: 'Tooltip for the Delivery Max parameter',
    enumValue: ParameterName.DELIVERY_MAX_PARAM,
  },

  parameterDirectDelPickingTooltip: {
    id: 'parameterDirectDelPickingTooltip',
    defaultMessage:
      'Maximum number of extra pallets that the store can receive for an article to maximize filling rate in the trucks',
    description: 'Tooltip for the direct delivery picking parameter',
    enumValue: ParameterName.DIRECT_DEL_PICKING,
  },
  parameterFlexibilityPctTooltip: {
    id: 'parameterFlexibilityPctTooltip',
    defaultMessage:
      'The percentage of the in-delivery amount that can be placed flexibly (in %)',
    description: 'Tooltip for the flexibility percent parameter',
    enumValue: ParameterName.FLEXIBILITY_PCT,
  },
  parameterAvgHandstackVolumeTooltip: {
    id: 'parameterAvgHandstackVolumeTooltip',
    defaultMessage: 'Average volume per handstack location (in m3)',
    description:
      'Tooltip for the average volume per handstack location parameter',
    enumValue: ParameterName.HANDSTACK_CAP_FACTOR,
  },
  parameterMaxSafetyStockDTooltip: {
    id: 'parameterMaxSafetyStockDTooltip',
    defaultMessage: 'Maximum safety stock factor coverage in days',
    description: 'Tooltip for the max safety stock days parameter',
    enumValue: ParameterName.MAX_SAFETY_STOCK_D,
  },
  parameterMinSafetyStockTooltip: {
    id: 'parameterMinSafetyStockTooltip',
    defaultMessage:
      'User defined minimum quantity (in pieces or meters) for a single purchase.',
    description: 'Tooltip for the min safety stock parameter',
    enumValue: ParameterName.MIN_SAFETY_STOCK,
  },
  parameterOrderFullPltOnlyTooltip: {
    id: 'parameterOrderFullPltOnlyTooltip',
    defaultMessage:
      'On = only order full pallets for the article\nOff = no such rule',
    description: 'Tooltip for the forcing full pallet orders parameter',
    enumValue: ParameterName.ORDER_FULL_PLT_ONLY,
  },
  parameterOverstockLimitDaysTooltip: {
    id: 'parameterOverstockLimitDaysTooltip',
    defaultMessage:
      'Maximum number of forecasted daily sales that a sales space is allowed to cover',
    description: 'Tooltip for the overstock limit days parameter',
    enumValue: ParameterName.OVERSTOCK_LIMIT_DAYS,
  },
  parameterPalletRoundFactorTooltip: {
    id: 'parameterPalletRoundFactorTooltip',
    defaultMessage:
      'The percentage of a pallet at which the in delivery amount is rounded up from a multipack quantity to a pallet quantity.',
    description: 'Tooltip for the pallet round factor parameter',
    enumValue: ParameterName.PALLET_ROUND_FACTOR,
  },
  parameterBiggestPeakdayFactorTooltip: {
    id: 'parameterBiggestPeakdayFactorTooltip',
    defaultMessage:
      'The percentage of a pallet at which the in delivery amount is rounded up from a multipack quantity to a pallet quantity.',
    description: 'Tooltip for the biggest peakday factor parameter',
    enumValue: ParameterName.PEAK_DAY_FACTOR_PCT,
  },
  parameterRangeAllocSfWhTooltip: {
    id: 'parameterRangeAllocSfWhTooltip',
    defaultMessage:
      'The threshold for dividing furniture articles by turnover in pieces into either self serve or warehouse shown in percentage',
    description: 'Tooltip for the range allocation ratio parameter',
    enumValue: ParameterName.RANGE_ALLOC_RATIO,
  },
  parameterUnitLoadLimitTooltip: {
    id: 'parameterUnitLoadLimitTooltip',
    defaultMessage:
      'This parameter limits the DTFP+ (in number of pallets) for high volume products. Only valid for DT=1 (Pallet) articles.',
    description: 'Tooltip for the unit load limit parameter',
    enumValue: ParameterName.UNIT_LOAD_LIMIT,
  },
  parameterCommQtyTooltip: {
    id: 'parameterCommQtyTooltip',
    defaultMessage:
      'On = calculate commercial quantity\nOff = do not use commercial quantity',
    description: 'Tooltip for the calculating commercial quantity parameter',
    enumValue: ParameterName.COMM_QTY_LIMIT_DAYS,
  },
  parameterHighTurnoverMarkTooltip: {
    id: 'parameterHighTurnoverMarkTooltip',
    defaultMessage:
      'A percentage of HFB articles measured by turnover in pieces which receive the DTFP+ as recommended sales space quantity (stable direct flow)',
    description: 'Tooltip for the turn over rank DTFP+',
    enumValue: ParameterName.TURNOVERRANKDTFPP,
  },

  parameterLowTurnoverMarkTooltip: {
    id: 'parameterLowTurnoverMarkTooltip',
    defaultMessage:
      'A percentage of HFB articles measured by turnover in pieces which receive the MIN as recommended sales space quantity (indirect flow)',
    description: 'Tooltip for the min turn over rank',
    enumValue: ParameterName.TURNOVERRANKMIN,
  },

  parameterTurnoverMarkDTFPTooltip: {
    id: 'parameterTurnoverMarkDTFPTooltip',
    defaultMessage:
      'A percentage of HFB articles measured by turnover in pieces which receive the DTFP as recommended sales space quantity (direct flow)',
    description: 'Tooltip for the turn over rank DTFP',
    enumValue: ParameterName.TURNOVERRANKDTFP,
  },
  parameterSmallStoreMinDeliveryQtyTooltip: {
    id: 'parameterSmallStoreMinDeliveryQtyTooltip',
    defaultMessage: 'Small Store Minimum Delivery Quantity',
    description:
      'Tooltip for the Small Store Minimum Delivery Quantity parameter',
    enumValue: ParameterName.SMALL_STORE_MINIMUM_DELIVERY_QUANTITY,
  },
  parameterSlmDirFlowGreenTooltip: {
    id: 'parameterSlmDirFlowGreenTooltip',
    defaultMessage:
      'Green threshold for the direct flow traffic light shown in the summary row in O11 and in the Time View in O16',
    description:
      'Tooltip for the SLM direct flow green threshold parameter (F6)',
    enumValue: ParameterName.SLM_DIR_FLOW_GREEN,
  },
  parameterSlmDirFlowYellowTooltip: {
    id: 'parameterSlmDirFlowYellowTooltip',
    defaultMessage:
      'Yellow threshold for the direct flow traffic light shown in the summary row in O11 and in the Time View in O16',
    description:
      'Tooltip for the SLM direct flow yellow threshold parameter (F6)',
    enumValue: ParameterName.SLM_DIR_FLOW_YELLOW,
  },
  parameterSlmExcessiveDaysTooltip: {
    id: 'parameterSlmExcessiveDaysTooltip',
    defaultMessage:
      'Number of days considered when calculating Moves per Sold m3 to filter articles with too high picks. Does not reflect the KPI measurement.',
    description: 'Tooltip for the SLM Excessive Days parameter (F6)',
    enumValue: ParameterName.SLM_EXCESSIVE_DAYS,
  },
  parameterSlmExcessiveLimitTooltip: {
    id: 'parameterSlmExcessiveLimitTooltip',
    defaultMessage:
      'Threshold value for the too high picks filter in O11. Unit: movements divided by sold m3 (same as SGF Handlings measurement).',
    description: 'Tooltip for the SLM Excessive Limit parameter (F6)',
    enumValue: ParameterName.SLM_EXCESSIVE_LIMIT,
  },
  parameterSlmMinIndelAmountTooltip: {
    id: 'parameterSlmMinIndelAmountTooltip',
    defaultMessage:
      'Minimum number of pieces for an in-delivery, defined by securing a minimum span between the Replenishment point and Max On Hand',
    description: 'Tooltip for the Minimum Indelivery Amount parameter (F6)',
    enumValue: ParameterName.SLM_MIN_INDEL_AMOUNT,
  },
  parameterSlmNewArtWeeksTooltip: {
    id: 'parameterSlmNewArtWeeksTooltip',
    defaultMessage:
      'Number of weeks after the sales start date that an article is considered a new article',
    description: 'Tooltip for the SLM New Article Weeks parameter (F6)',
    enumValue: ParameterName.SLM_NEW_ART_WEEKS,
  },
  parameterSlmSlidStartDaysTooltip: {
    id: 'parameterSlmSlidStartDaysTooltip',
    defaultMessage:
      'Number of days before the sales start lead time that an article should be ordered. Affects the Automatic Replenishment Code switch.',
    description: 'Tooltip for the SLM SL-ID Start Days parameter (F6)',
    enumValue: ParameterName.SLM_SLID_START_DAYS,
  },
  parameterSlmWarnAssqDaysTooltip: {
    id: 'parameterSlmWarnAssqDaysTooltip',
    defaultMessage:
      'Number of days the SLM tool looks into the future when creating warnings for articles that will go below MIN or above MAX',
    description: 'Tooltip for the SLM Warning ASSQ Days parameter (F6)',
    enumValue: ParameterName.SLM_WARN_ASSQ_DAYS,
  },
  parameterSlmWarnUnplanDaysTooltip: {
    id: 'parameterSlmWarnUnplanDaysTooltip',
    defaultMessage:
      'Number of days the SLM tool looks into the future when creating warnings for articles that will become unplanned',
    description: 'Tooltip for the SLM Warning Unplanned Days parameter (F6)',
    enumValue: ParameterName.SLM_WARN_UNPLAN_DAYS,
  },
  alertLocLocShortageTooltip: {
    id: 'alertLocLocShortageTooltip',
    defaultMessage:
      'This parameter turns local-local shortage alerts either on or off for the store',
    description: 'Tooltip for the Alert local-local shortage parameter (F6)',
    enumValue: ParameterName.ALERT_LOC_LOC_SHORT,
  },
  alertAssqOverMaxTooltip: {
    id: 'alertAssqOverMaxTooltip',
    defaultMessage:
      'This parameter turns over max alerts either on or off for the store',
    description: 'Tooltip for the Alert ASSQ over max parameter (F6)',
    enumValue: ParameterName.ALERT_OVER_MAX,
  },
  alertAssqUnderMinTooltip: {
    id: 'alertAssqUnderMinTooltip',
    defaultMessage:
      'This parameter turns under min alerts either on or off for the store',
    description: 'Tooltip for the Alert ASSQ under min parameter (F6)',
    enumValue: ParameterName.ALERT_UNDER_MIN,
  },
  alertUnplannedArticleTooltip: {
    id: 'alertUnplannedArticleTooltip',
    defaultMessage:
      'This parameter turns unplanned alerts either on or off for the store',
    description: 'Tooltip for the Alert unplanned article parameter (F6)',
    enumValue: ParameterName.ALERT_UNPLANNED_ART,
  },
});

// Generic constraint violation messages for fields with composite constraints (e.g. SMDQ).
// Attribute names are passed as-is from the backend.
export const constraintViolationMessages = defineMessages({
  parameterNotAllowed: {
    id: 'constraintViolationParameterNotAllowed',
    defaultMessage: 'Value is not allowed for this article',
    description:
      'Shown when the parameter is not allowed at all for the current article/context',
  },
  notAllowed: {
    id: 'constraintViolationNotAllowed',
    defaultMessage: '{attribute}: not allowed',
    description:
      'Shown when a constraint attribute disallows the parameter entirely',
  },
  belowMin: {
    id: 'constraintViolationBelowMin',
    defaultMessage: '{attribute}: value must be at least {min}',
    description: 'Shown when the entered value is below the constraint minimum',
  },
  aboveMax: {
    id: 'constraintViolationAboveMax',
    defaultMessage: '{attribute}: value must be at most {max}',
    description: 'Shown when the entered value is above the constraint maximum',
  },
});

const parametersMessages = {
  ...messages,
  constraints: constraintMessages,
  useCases: useCaseMessages,
  parameterShortMessages,
  parameterTooltipMessages,
};

export default parametersMessages;
